import { Component, Input } from '@angular/core';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { AngularModule } from '../../../../modules/angular.module';

@Component({
	selector: 'app-form-submit-button',
	standalone: true,
	imports: [AngularModule, NzSpinModule],
	templateUrl: './form-submit-button.component.html',
	styleUrl: './form-submit-button.component.scss',
})
export class FormSubmitButtonComponent {
	@Input('disabled') public disabled: boolean = false;
	@Input('loading') public loading: boolean = false;
}
